<template>
<router-link 
  :key="bolsa.name"
  class="botao_bolsas"
  :to="{ path: '/bolsasdeestudo/'+bolsa.Name }">
    <div class="col5-unit">
      <div :class="[bolsa.Name]" class="bolsas_color">
        <div class="bolsa_color" :class="[bolsa.Name]" />
      </div>
      <div :class="[bolsa.Name]" class="bolsas_logo">
        <img :src="bolsaslogo[bolsa.Name]" />
      </div>
    </div>
</router-link>
</template>

<script>
import fundo from "@/assets/images/sas_logo_fundo.png";
import dges from "@/assets/images/logo_bolsa_dges.png";
import afa from "@/assets/images/sas_logo_afa.png";
import santander from "@/assets/images/logo_bolsa_santander.png";
import blandy from "@/assets/images/sas_logo_blandy.png";

export default {
  props:["bolsa"],
  setup () {
    
    const bolsaslogo = {
      'bolsa-dges': dges,
      'bolsa-santander': santander,
      'bolsa-afa': afa,
      'bolsa-blandy': blandy,
      'fundo-de-apoio-de-emergencia': fundo
    }

    return {
      bolsaslogo
    }
  }
}
</script>

<style lang="scss" scoped>
.bolsas_logo img {
  height: auto;
  width: 220px;
  margin: 0 auto;
  display: block;
}


.bolsas_color {
  background-size: 265px;
  background-repeat: no-repeat;
  display: block;
  position: relative;
  z-index: 5;
  height: 280px;
  object-fit: cover;
}

.bolsa_color {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  z-index: 1;
}

.botao_bolsas:hover .bolsas_logo:after{
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: rgba(0,0,0,.2);
}

.bolsas_color {
  display: none;
}

.bolsas_logo {
  height: 100px;
  width: 260px;
  position: relative;
}

.bolsas_color, .bolsas_logo {
  margin-right: 5px;
  margin-left: 5px;
  -webkit-box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
  box-shadow: 3px 2px 8px 0px rgba(77,77,77,0.25);
}

.botao_bolsas{
  position: relative;
}

.botao_bolsas:hover .bolsa_color.bolsa-dges{
  background-color: rgba(32,42,88,0.65);
}
.botao_bolsas:hover .bolsa_color.bolsa-santander{
  background-color: rgba(120,3,3,0.65);
}
.botao_bolsas:hover .bolsa_color.bolsa-afa{
  background-color: rgba(136,141,139,0.65);
}
.botao_bolsas:hover .bolsa_color.bolsa-blandy{
  background-color: rgba(143,108,55,0.65);
}
.botao_bolsas:hover .bolsa_color.fundo-de-apoio-de-emergencia{
  background-color: rgba(115,159,151,0.65);
}


.bolsas_logo.bolsa-dges{
    background-color: #11416b;
}
.bolsas_logo.bolsa-santander{
    background-color: #ec1e24;
}
.bolsas_logo.bolsa-afa{
    background-color: #F9BC30;
}
.bolsas_logo.bolsa-blandy{
    background-color: #e1e3e5;
}
.bolsas_logo.fundo-de-apoio-de-emergencia{
    background-color: #a3d9f0;
}

.botao_bolsas:nth-of-type(4) img{
  width: 203px;
  padding-top: 10px;
}

.botao_bolsas:nth-of-type(3) img{
  width: 203px;
  padding-top: 13px;
}


@media (max-width: 1400px) {

  .bolsas_color {
    display: none;
  }

  .bolsas_logo {
    width: 210px;
  }

  .bolsas_logo img {
    width: 205px;
  }

  .botao_bolsas:last-of-type img {
    width: 154px;
    padding-left: 21px;
  }

  .botao_bolsas:nth-of-type(3) img {
    width: 180px;
  }

}


@media (max-width: 1100px) {

  .bolsas_logo img {
    width: 185px;
  }

  .bolsas_logo {
    width: 170px;
    height: 85px;
  }


  .botao_bolsas:last-of-type img {
    margin-left: 0px;
  }

  .botao_bolsas:nth-of-type(3) img {
    width: 121px;
    padding-top: 10px;
  }

  .botao_bolsas:nth-of-type(4) img {
    width: 120px;
    padding-top: 10px;
  }

}

@media (max-width: 900px) {
  .bolsas_logo {
    height: 65px;
    margin-bottom: 10px;
  }
}


@media (max-width: 700px) {

  .bolsas_logo img {
    width: 130px;
  }

  .bolsas_logo {
    width: 170px;
  }

}

</style>